<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    max-width="50%"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider :name="$t(dateName)" rules="required" v-slot="{ errors }">
        <v-text-field
          v-model="pickerDate"
          readonly
          v-on="on"
          :disabled="isAllTextFieldDisabled"
          @keyup.enter="keyupEnter"
          clearable
          :error-messages="errors[0]"
        >
          <template v-slot:label>
            <span class="red--text">
              <strong>* </strong>
            </span>
            {{ $t(dateName) }}
          </template>
        </v-text-field>
      </ValidationProvider>
    </template>
    <v-date-picker
      v-model="pickerDate"
      :locale="getLocale"
      @input="showPicker = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerRequired',
  props: {
    dateName: {
      type: String
    },
    isAllTextFieldDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPicker: false,
      pickerDate: null
    }
  },
  mounted () {
    // this.pickerDate = this.$moment(new Date()).format('YYYY-MM-DD')
  },
  computed: {
    getLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    keyupEnter (event) {
      this.showPicker = false
      this.$emit('keyupEnter', event)
    }
  },
  components: {},
  watch: {
    pickerDate (newVal) {
      let timestamp = Date.parse(newVal + ' 00:00:00:000')
      this.$emit('setDate', timestamp)
    }
  }
}
</script>

<style></style>
